import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { ChangeNavbar } from '../actions';

import './Subventions.css';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import logo_generalitat from '../images/subventions/logo_generalitat.png';
import logo_fse from '../images/subventions/logo_FSE.png';
import logo_mess from '../images/subventions/logo_MESS.png';

class Subventions extends Component {
  constructor(props) {
    super(props);
    this.props.SetHeaderNavbar(false);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <section className="content no-header">
        <Container>
          <Row>
            <Col>
              <h1><Translate id="subventions.title">Subvenciones</Translate></h1>
            </Col>
          </Row>

          <br/>

          <Row>
            <Col className="text-justify">
              <h2>ESEILS/2019/140/46</h2>
              <p>
                <Translate id="subventions.sub2">
                  GONE MAD STUDIOS COOP. V., CON NIF F-40556862, Declara que es beneficiaria de una subvención por importe de 12.289,60 euros (expediente ESEILS/2019/140/46) por haber incorporado, con carácter indefinido, como socios trabajadores a 2 personas desempleadas. Dicha subvención ha sido concedida por la Generalitat Valenciana al amparo de la orden 23/2016, de 27 de octubre, de la conselleria de economía sostenible, sectores productivos, comercio y trabajo, y financiada con fondos del Ministerio de Empleo y Seguridad Social.
                </Translate>
              </p>
            </Col>
          </Row>
          <br/>
          <Row className="subvention-logos text-center">
            <Col md="4">
              <img src={logo_generalitat} alt="Generalitat Valenciana"/>
            </Col>
            <Col md="4">
              <img src={logo_mess} alt="Fondo Social Europeo"/>
            </Col>
            <Col md="4">
              <img src={logo_fse} alt="Ministerio de Empleo y Seguridad Social"/>
            </Col>
          </Row>

          <Row><Col> <br/><hr/><br/> </Col></Row>

          <Row>
            <Col className="text-justify">
              <h2>ESEILS/2019/52/46</h2>
              <p>
                <Translate id="subventions.sub1">
                  GONE MAD STUDIOS COOP. V., CON NIF F-40556862, Declara que es beneficiaria de una subvención por importe de 16.000 euros (expediente ESEILS/2019/52/46) por haber incorporado, con carácter indefinido, como socios trabajadores a 2 personas desempleadas. Dicha subvención ha sido concedida por la Generalitat Valenciana al amparo de la orden 23/2016, de 27 de octubre, de la conselleria de economía sostenible, sectores productivos, comercio y trabajo, y financiada con fondos del Ministerio de Empleo y Seguridad Social.
                </Translate>
              </p>
            </Col>
          </Row>
          <br/>
          <Row className="subvention-logos text-center">
            <Col md="4">
              <img src={logo_generalitat} alt="Generalitat Valenciana"/>
            </Col>
            <Col md="4">
              <img src={logo_mess} alt="Fondo Social Europeo"/>
            </Col>
            <Col md="4">
              <img src={logo_fse} alt="Ministerio de Empleo y Seguridad Social"/>
            </Col>
          </Row>
        </Container>
      </section>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return { }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(Subventions);
